var _excluded = ["status", "number"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { useMemo } from 'react';
import { forwardRef } from '../../../utils';
import { useStyleConfig } from '../../../utils/use-style-config';
import { _BaseBadge } from '../../internal';
import { jsx as _jsx } from "react/jsx-runtime";
var LENGTH = 2; // preparation for dynamic length of characters to detect the max number to display.

var FIX_SIZE_LENGTH = 2; // according to the design up to 2 character the counter has fixed size

export var Counter = forwardRef((_ref, ref) => {
  var {
    status,
    number
  } = _ref,
      rest = _objectWithoutProperties(_ref, _excluded);

  var numberMask = useMemo(() => {
    var maxNumber = Math.pow(10, LENGTH) - 1;
    return maxNumber < number ? "+".concat(maxNumber) : "".concat(number);
  }, [number]);
  var isFixedSize = numberMask.length <= FIX_SIZE_LENGTH;
  var styles = useStyleConfig('Counter', {
    status,
    isFixedSize
  });
  return /*#__PURE__*/_jsx(_BaseBadge, _objectSpread(_objectSpread({
    "data-component": "Counter",
    status: status
  }, rest), {}, {
    __css: styles,
    ref: ref,
    label: numberMask
  }));
});
Counter.displayName = 'Counter';
//# sourceMappingURL=Counter.js.map